import React, { useState } from 'react';
import { shouldShowTestbedBanner, getGoLiveDate, formatDate } from '../config/environment';
import './TestbedBanner.css';

const TestbedBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !shouldShowTestbedBanner()) return null;
  const goLive = getGoLiveDate();

  return (
    <div className="testbed-banner">
      <span className="testbed-badge">TEST PLATFORM</span>
      <span className="testbed-text">
        This is a test environment — not for real money.
        {goLive && (
          <>
            {' '}
            Going live on <strong>{formatDate(goLive)}</strong>.
          </>
        )}
      </span>
      <button
        className="testbed-close"
        onClick={() => setDismissed(true)}
        aria-label="Close banner"
        title="Close"
      >
        ✕
      </button>
    </div>
  );
};

export default TestbedBanner;
